<template>
	<div class="addr-detail-page">
		<div class="key-val input-key-val">
			<span class="key">收货人</span>
			<input class="val-input" type="text" v-model="form.name" placeholder="请填写收货人姓名">
		</div>
		<div class="key-val input-key-val">
			<span class="key">手机号码</span>
			<input class="val-input" type="text" v-model="form.phoneNumber" placeholder="请填写手机号码">
		</div>
		<div class="key-val input-key-val">
			<span class="key">所在地区</span>
			<div class="val-input val-input-addr" @click="showAreaPopup" v-if="form.selectedArea">
				<span class="text-addr">{{ form.selectedArea }}</span>
				<img class="icon-addr-r" src="@/assets/images/product/icon_addr_r.png" />
			</div>
			<div class="val-input val-input-addr" @click="showAreaPopup" v-else>
				<span class="text-addr grey">省份 城市 地区 街道</span>
				<img class="icon-addr-r" src="@/assets/images/product/icon_addr_r.png" />
			</div>
		</div>
		<div class="key-val input-key-val">
			<span class="key">详细地址</span>
			<input class="val-input" type="text" v-model="form.detailAddress" placeholder="道路、小区、单元室、门牌等">
		</div>
		<div class="key-val input-key-val al">
			<span class="key">标签</span>
			<div class="val-tags">
				<span :class="form.tag == '0' ? 'val-tag val-tag-s' : 'val-tag'" @click="changeTag('0')">家</span>
				<span :class="form.tag == '1' ? 'val-tag val-tag-s' : 'val-tag'" @click="changeTag('1')">学校</span>
				<span :class="form.tag == '2' ? 'val-tag val-tag-s' : 'val-tag'" @click="changeTag('2')">公司</span>
			</div>
		</div>
		<div class="key-val input-key-val">
			<span class="key">设为默认地址</span>
			<img class="icon-default" v-if="form.isDefault == 1" src="@/assets/images/product/icon_default.png"
				@click="form.isDefault = 0" />
			<span class="icon-default-none" v-else @click="form.isDefault = 1"></span>
		</div>
		<div class="btn-box">
			<div class="btn" @click="submit">保存</div>
		</div>
		<van-popup v-model="show" round position="bottom">
			<van-cascader v-model="form.selectedAreaId" active-color="#00754A" title="请选择所在地区"
				:field-names="{ text: 'name', value: 'id', children: 'children' }" :options="options" @close="show = false"
				@change="changeAddressOption" @finish="onFinish" />
		</van-popup>
	</div>
</template>

<script>

import { post } from 'api/post'
import { get } from 'api/get'
import TabBar from '@/components/tabBar/index'

export default {
	name: 'User',
	components: {
		TabBar
	},
	data() {
		return {
			title: '新建收货地址',
			options: [],
			show: false,
			value: '',
			form: {
				id: '',
				name: '',
				phoneNumber: '',
				province: '',
				provinceId: '',
				city: '',
				cityId: '',
				region: '',
				regionId: '',
				street: '',
				streetId: '',
				detailAddress: '',
				tag: '',
				isDefault: 0,
				memberId: '',
				postCode: '',
				selectedArea: '',
				selectedAreaId: ''
			}
		};
	},
	created() {
		if (this.$route.query.id) {
			this.title = '更新收货地址'
			this.getAddressDetail(this.$route.query.id)
		} else {
			this.loadProvince()
		}
	},
	methods: {
		getAddressDetail(id) {
			let self = this
			get('member/receiveAddress/' + id).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))
					let address = ''
					if (resData.province && resData.province != '') {
						address += resData.province
					}

					if (resData.city && resData.city != '') {
						address += resData.city
					}

					if (resData.region && resData.region != '') {
						address += resData.region
					}

					if (resData.street && resData.street != '') {
						address += resData.street
					}

					self.form = resData;
					self.form.selectedArea = address;

					self.loadProvince()
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#ee0a24'
					})
				}
			})
		},
		loadProvince() {
			let self = this
			get('area/listProvince').then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))
					if (resData && resData.length > 0) {
						resData.forEach(item => item.children = [])
						this.$set(self, 'options', resData)

						// 用于更新地址
						if (this.form.id && this.form.id != '') {
							this.backFillAddressOption(this.form.provinceId, 0)
						}
					}
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#ee0a24'
					})
				}
			})
		},
		showAreaPopup() {
			this.show = true
		},
		getSelectedAddressOption(options, value) {
			for (let i = 0; i < options.length; i++) {
				let option = options[i]
				if (option.id == value) {
					return option
				}

				if (option.children && option.children.length > 0) {
					option = this.getSelectedAddressOption(option.children, value)
					if (option && option.id == value) {
						return option
					}
				}
			}

			return null
		},
		changeAddressOption({ value, tabIndex }) {
			console.log(value)
			console.log(tabIndex)

			// 四级街道直接跳过不查询
			if (tabIndex == 3) {
				return;
			}

			let self = this
			get('area/listChild/' + value).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))

					if (resData && resData.length > 0) {
						// 三级地区的街道不增加children属性
						if (tabIndex < 2) {
							resData.forEach(item => item.children = [])
						}

						let selectedOption = self.getSelectedAddressOption(self.options, value)

						this.$set(selectedOption, 'children', resData)
					}
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#ee0a24'
					})
				}
			})
		},
		backFillAddressOption(value, tabIndex) {
			console.log(value)
			console.log(tabIndex)

			// 四级街道直接跳过不查询
			if (tabIndex == 3) {
				return;
			}

			let self = this
			get('area/listChild/' + value).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					let resData = JSON.parse(JSON.stringify(res.data))

					if (resData && resData.length > 0) {
						// 三级地区的街道不增加children属性
						if (tabIndex < 2) {
							resData.forEach(item => item.children = [])
						}

						let selectedOption = self.getSelectedAddressOption(self.options, value)

						this.$set(selectedOption, 'children', resData)
					}

					if (self.form.province && self.form.province != '') {
						this.$set(self.form, 'selectedAreaId', self.form.provinceId)
					}

					if (self.form.city && self.form.city != '') {
						this.$set(self.form, 'selectedAreaId', self.form.cityId)
					}

					if (self.form.region && self.form.region != '') {
						this.$set(self.form, 'selectedAreaId', self.form.regionId)
					}

					if (self.form.street && self.form.street != '') {
						this.$set(self.form, 'selectedAreaId', self.form.streetId)
					}

					if (tabIndex == 0 && self.form.cityId) {
						self.backFillAddressOption(self.form.cityId, tabIndex + 1)
					}

					if (tabIndex == 1 && self.form.regionId) {
						self.backFillAddressOption(self.form.regionId, tabIndex + 1)
					}

					if (tabIndex == 2 && self.form.streetId) {
						self.backFillAddressOption(self.form.streetId, tabIndex + 1)
					}
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#ee0a24'
					})
				}
			})
		},
		onFinish({ selectedOptions }) {
			this.show = false;
			this.form.selectedArea = selectedOptions.map((option) => option.name).join('');
			for (let i = 0; i < selectedOptions.length; i++) {
				let id = selectedOptions[i].id
				let name = selectedOptions[i].name
				if (i == 0) {
					this.form.province = name
					this.form.provinceId = id
				}
				if (i == 1) {
					this.form.city = name
					this.form.cityId = id
				}
				if (i == 2) {
					this.form.region = name
					this.form.regionId = id
				}
				if (i == 3) {
					this.form.street = name
					this.form.streetId = id
				}
			}
		},
		changeTag(val) {
			if (this.form.tag == val) {
				this.form.tag = ''
				return
			}

			this.$set(this.form, 'tag', val)
		},
		submit() {
			if (!this.form.name) {
				this.$toast('请填写收货人姓名');
				return;
			}

			if (!this.form.phoneNumber) {
				this.$toast('请填写11位手机号码');
				return;
			}

			// 手机号验证
			const regexp = /^1\d{10}$/
			if (!regexp.test(this.form.phoneNumber)) {
				this.$toast('请填写11位手机号码');
				return;
			}

			if (!this.form.selectedArea) {
				this.$toast('请选择所在地区');
				return;
			}

			if (!this.form.detailAddress) {
				this.$toast('请填写详细地址');
				return;
			}

			let self = this
			let messageText = '创建成功'
			let url = 'member/receiveAddress/add'
			if (self.form.id && self.form.id != '') {
				messageText = '更新成功'
				url = 'member/receiveAddress/update/' + self.form.id
			}
			post(url, this.form).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					self.$toast(messageText);
					if (this.$route.query.fromPage) {
						this.$router.push("/" + this.$route.query.fromPage);
					} else {
						this.$router.push("/addressList");
					}
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#ee0a24'
					})
				}
			})
		},
		onClickLeft() {
			this.$router.push("/addressList");
		}
	},
};
</script>


<style scoped lang="less">
.addr-detail-page {
	box-sizing: border-box;
	padding: 10px 15px;
	height: 100vh;
	background-color: #fff;

	.key-val {
		margin: 0 0 10px;
		padding: 0 2px;
		min-height: 16px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: space-between;
		align-items: flex-start;

		.key {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 13px;
			color: #666666;
			line-height: 16px;
		}

		.val {
			text-align: right;
			width: 240px;
			line-height: 18px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 13px;
			color: #333333;
		}



		.img {
			width: 149px;
		}
	}

	.input-key-val {
		align-items: center;
		height: 40px;
		position: relative;

		.key {
			width: 80px;

			.red-x {
				color: #FF4E4E;
				font-size: 13px;
			}
		}

		.val-input {
			box-sizing: border-box;
			padding: 12px;
			flex: 1;
			border: none;
			height: 40px;
			line-height: 40px;
			background: #F7F7F7;
			border-radius: 10px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 13px;
			color: #333333;

			.text-addr {
				height: 40px;
				line-height: 40px;
				width: 220px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #333;
			}

			.icon-addr-r {
				width: 14px;
				height: 14px;
			}

			.grey {
				color: #CCCCCC;
			}
		}

		.val-input::placeholder {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 13px;
			color: #CCCCCC;
		}

		.val-input-addr {
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: center;
		}

		.edit-tt {
			position: absolute;
			top: 14px;
			right: 12px;
			display: flex;
			align-content: center;
			justify-content: center;
			align-items: center;

			.edit-tt-text {
				height: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #00754A;
				line-height: 14px;
			}

			.edit-tt-icon {
				width: 12px;
				height: 12px;
			}

		}

		.val-tags {
			.val-tag {
				margin-right: 10px;
				height: 28px;
				line-height: 28px;
				box-sizing: border-box;
				padding: 12px;
				background: #F7F7F7;
				border-radius: 10px;
				font-weight: 400;
				font-size: 13px;
				color: #999;
			}

			.val-tag-s {
				background: rgba(0, 117, 74, 0.06);
				color: #00754A;
			}
		}

		.icon-default {
			width: 16px;
			height: 16px;
		}

		.icon-default-none {
			box-sizing: border-box;
			width: 16px;
			height: 16px;
			background: #FFFFFF;
			border-radius: 4px;
			border: 1px solid #EEEEEE;
		}
	}

	.al {
		justify-content: flex-start
	}


	.icon-val {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 5px;

		.icon {
			width: 16px;
			height: 16px;
			margin-right: 6px;
		}

		.val {
			height: 18px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 15px;
			color: #00754A;
			line-height: 18px;
		}
	}

	.explain {
		width: 345px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 12px;
		color: #666666;
		line-height: 16px;
		margin-bottom: 90px;
	}

	.remark-box {
		background: #F7F7F7;
		border-radius: 10px;
	}

	.addr-list {
		max-height: 350px;
		padding-bottom: 30px;
		overflow: auto;

		.addr-item {
			box-sizing: border-box;
			margin: 10px auto;
			padding: 9px 10px;
			width: 345px;
			background: #F7F7F7;
			border-radius: 6px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 12px;
			color: #333333;
			line-height: 16px;
		}

		.addr-item-s {
			color: #00754A;
			border: 1px solid #00754A;
			background: rgba(0, 117, 74, 0.06);
		}

		.addr-list-item {
			box-sizing: border-box;
			margin: 10px auto;
			width: 345px;
			height: 60px;
			background: #F7F7F7;
			border-radius: 10px;
			position: relative;

			.name-tel {
				height: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 13px;
				color: #333333;
				line-height: 16px;
				position: absolute;
				top: 12px;
				left: 12px;

				.tel {
					margin-left: 10px;
					font-weight: 400;
				}

				.tag-b {
					margin: 0 6px 0 10px;
					padding: 0 4px;
					height: 16px;
					background: #00754A;
					border-radius: 4px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #FFFFFF;
					line-height: 16px;
				}

				.tag {
					padding: 0 4px;
					height: 16px;
					background: rgba(0, 117, 74, 0.06);
					border-radius: 4px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #00754A;
					line-height: 16px;
				}
			}

			.icon-addr {
				width: 14px;
				height: 14px;
				position: absolute;
				top: 34px;
				left: 12px;
			}

			.addr-d {
				position: absolute;
				top: 34px;
				left: 30px;
				width: 280px;
				height: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #666666;
				line-height: 14px;
				text-align: left;
				font-style: normal;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.icon-edit {
				width: 16px;
				height: 16px;
				position: absolute;
				top: 22px;
				right: 14px;
			}

		}

	}

	.tt-list {
		max-height: 350px;
		padding-bottom: 30px;
		overflow: auto;

		.tt-list-item {
			box-sizing: border-box;
			margin: 12px auto;
			width: 345px;
			height: 98px;
			background: #F7F7F7;
			border-radius: 10px;
			position: relative;

			.tt-name-tag {
				position: absolute;
				top: 12px;
				left: 12px;

				.tt-name {
					margin-right: 10px;
					height: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 13px;
					color: #333333;
					line-height: 16px;
				}

				.tt-tag {
					width: 30px;
					height: 16px;
					background: rgba(0, 117, 74, 0.06);
					border-radius: 4px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #00754A;
					line-height: 16px;
					text-align: center;
				}

			}

			.tt-cont {
				position: absolute;
				top: 34px;
				left: 12px;
				width: 270px;
				height: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #333333;
				line-height: 14px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.tt-line {
				position: absolute;
				top: 58px;
				left: 12px;
				width: 323px;
				height: 1px;
				background-color: #EEEEEE;
			}

			.tt-btn {
				width: 48px;
				height: 26px;
				background: #00754A;
				border-radius: 6px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 12px;
				color: #FFFFFF;
				line-height: 26px;
				text-align: center;
				position: absolute;
				top: 16px;
				right: 12px;
			}

			.tt-d {
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-content: center;
				justify-content: center;
				align-items: center;
				position: absolute;
				bottom: 12px;
				left: 12px;

				.tt-d-icon {
					width: 16px;
					height: 16px;
				}

				.tt-d-text {
					margin-left: 8px;
					height: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #666666;
					line-height: 14px;
				}
			}

			.tt-icon-edit {
				width: 16px;
				height: 16px;
				position: absolute;
				bottom: 12px;
				right: 40px;
			}

			.tt-icon-del {
				width: 16px;
				height: 16px;
				position: absolute;
				bottom: 12px;
				right: 12px;
			}

		}


	}

	.btn-box {
		position: fixed;
		left: 0;
		bottom: 0;
		width: 375px;
		height: 49px;
		background: #FFFFFF;
		padding: 5px 0 0;

		.btn {
			margin: 0 auto;
			width: 355px;
			height: 40px;
			background: #00754A;
			border-radius: 10px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 15px;
			color: #FFFFFF;
			line-height: 40px;
			text-align: center;
		}
	}

	.no-more {
		margin: 70px auto 130px;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;

		.img {
			width: 110px;
			height: 100px;
		}

		.tips {
			margin-top: 8px;
			height: 14px;
			font-size: 12px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #999999;
			line-height: 14px;
		}
	}

	.list {
		position: relative;
		padding-bottom: 65px;

		.item {
			margin: 0 auto 10px;
			width: 347px;
			height: 88px;

			.img {
				position: absolute;
				width: 100%;
				height: 88px;
				z-index: 0;
			}

			.content-info {
				position: relative;
				width: 100%;
				height: 88px;
				display: flex;

				.dot {
					position: absolute;
					top: 0;
					left: 0;
					width: 49px;
					height: 18px;
					background: linear-gradient(124deg, #ff906d 0%, #ff3d45 100%);
					border-radius: 10px 0px 10px 0px;
					font-size: 11px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #ffffff;
					line-height: 18px;
					text-align: center;
				}

				.left {
					width: 85px;
					display: flex;
					flex-direction: column;
					flex-wrap: nowrap;
					align-content: center;
					justify-content: center;
					align-items: center;

					.price {
						font-size: 0;
						font-family: 'DINA';
						font-weight: bold;
						color: #ff4e4e;
					}

					.condition {
						height: 16px;
						font-size: 11px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #ff4e4e;
						line-height: 16px;
					}
				}

				.content {
					flex: 1;

					.name {
						margin-top: 20px;
						width: 100%;
						height: 32px;
						font-size: 13px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						color: #333333;
						line-height: 16px;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
					}

					.condition-time {
						display: flex;
						flex-direction: row;
						flex-wrap: nowrap;
						align-content: center;
						justify-content: center;
						align-items: center;
						margin-top: 6px;

						.condition {
							margin-right: 4px;
							height: 9px;
							font-size: 9px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #00754a;
							line-height: 9px;
							white-space: nowrap;
						}

						.time {
							width: 100%;
							height: 12px;
							font-size: 10px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #999999;
							line-height: 12px;
							white-space: nowrap;
						}
					}
				}

				.right {
					width: 87px;
					display: flex;
					align-content: center;
					align-items: center;
					justify-content: center;

					.btn-get {
						width: 64px;
						height: 26px;
						background: #00754a;
						border-radius: 6px;
						font-size: 12px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						color: #ffffff;
						line-height: 26px;
						text-align: center;
					}

					.img {
						width: 57px;
						height: 44px;
						position: absolute;
						top: 0;
						right: 0;
					}

					.icon-d {
						width: 16px;
						height: 16px;
					}
				}
			}
		}
	}

	.coupon-s {
		max-height: 200px;
		overflow: auto;

		.coupon-grey {
			filter: grayscale(100%);
			/*fire*/
			-webkit-filter: grayscale(100%);
			/*chrome*/
			opacity: 0.6;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/view/address/detail.vue